var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"my-duty-widget",attrs:{"flat":""}},[(_vm.duty)?_c('duty-card',{attrs:{"duty":_vm.duty}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }